export const DATA_LAYER_EVENTS = {
  ADD_TO_CART: 'product.interact.manual.click.addToCart',
}

export const DATA_LAYER_CATEGORIES = {
  NAVIGATION: 'NV',
}
